module.exports = __webpack_public_path__ + "static/img/huaweiMatePad_128.9467a1e0.png";